import { z } from 'zod';

const tagInfoSchema = z.object({
	tagId: z.string(),
	tagNick: z.string(),
});

export const tagHealthNotificationMetadataSchema = z.object({
	lowBatteryTags: z.array(tagInfoSchema),
	unseenTags: z.array(tagInfoSchema),
});

export type ITagHealthNotificationMetadata = z.infer<typeof tagHealthNotificationMetadataSchema>;
